<div *ngIf="!this.dataSource?.data">
    <app-loading-message></app-loading-message>
</div>

<div *ngIf="this.dataSource?.data?.length == 0">
    <app-message-empty
        [title]="'No countries...'"
        [icon]="'https://image.flaticon.com/icons/svg/854/854881.svg'">
    </app-message-empty>
</div>

<div [hidden]="!this.dataSource?.data?.length">
    <app-searchbar
        [(value)]="filter"
        (valueChange)="applyFilter($event)"></app-searchbar>

    <div class="m-t-4">
        <table
            mat-table
            [dataSource]="dataSource"
            matSort>
            <ng-container matColumnDef="countryName">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Country name
                </th>
                <td
                    mat-cell
                    *matCellDef="let row">
                    <span>{{ row.countryName }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="countryCode">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Country Code
                </th>
                <td
                    mat-cell
                    *matCellDef="let row">
                    <span>{{ row.countryCode }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="td-small"></th>
                <td
                    mat-cell
                    *matCellDef="let row">
                    <span
                        ngbDropdown
                        class="dropdown"
                        *appIsPermitted="{
                            module: 'VELDA_LANGUAGES',
                            operator: 'OR',
                            actions: ['EDIT', 'DELETE']
                        }">
                        <button
                            type="button"
                            ngbDropdownToggle
                            class="button button--icon button--small dropdown-toggle"
                            id="dropdownMenuButton"></button>
                        <span
                            ngbDropdownMenu
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton">
                            <a
                                class="dropdown-item"
                                *appIsPermitted="{
                                    module: 'VELDA_LANGUAGES',
                                    operator: 'AND',
                                    actions: ['EDIT']
                                }"
                                (click)="openEditVeldaCountryModal(row)"
                                >Edit</a
                            >
                            <div
                                class="dropdown-divider"
                                *appIsPermitted="{
                                    module: 'VELDA_LANGUAGES',
                                    operator: 'AND',
                                    actions: ['EDIT', 'DELETE']
                                }"></div>
                            <a
                                class="dropdown-item color--red"
                                *appIsPermitted="{
                                    module: 'VELDA_LANGUAGES',
                                    operator: 'AND',
                                    actions: ['DELETE']
                                }"
                                (click)="openDeleteVeldaCountryModal(row)"
                                >Delete</a
                            >
                        </span>
                    </span>
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>

            <tr *matNoDataRow>
                <td colspan="3">No countries matching the filter "{{ filter }}"</td>
            </tr>
        </table>
    </div>
</div>
